/**
 * Converts a date string to a Date object
 * @param dateString
 * @returns {Date}
 */
export const stringToDateConvertor = (dateString) => {
    // check if data format is 21/08/2023
    if (dateString.includes('/')) {
        const [day, month, year] = dateString.split('/').map(Number);
        return new Date(year, month - 1, day);
    }else{
        return new Date(dateString);
    }

}
